import request from './request.js';
import {requestbody} from './request.js'
//开票数据台账导入
export async function importExcel (params = {}) {
	return await request('/red-letter/file/upload', 'post', params)
}
//开票数据台账分页查询
export async function findPage (params = {}) {
	return await request('/red-letter/page', 'get', params)
}

//开票数据台账分页查询
export async function redLetterDel (params = {}) {
	return await request('/red-letter/delete', 'post', params)
}